import { MapPin, Clock, Mail, Phone, Navigation } from "lucide-react";
import { ADDRESS, PHONE, PHONE_LINK, MAPS_LINK, Reveal, Eyebrow } from "../lib/data";

const Location = () => (
  <section className="py-20 lg:py-28 bg-white" data-testid="location-section">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal className="max-w-2xl">
        <Eyebrow>Locație & Program</Eyebrow>
        <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">Ne găsești ușor în Timișoara</h2>
      </Reveal>

      <div className="mt-12 grid lg:grid-cols-5 gap-8">
        <Reveal className="lg:col-span-2">
          <div className="bg-[#FBF7EF] rounded-2xl border border-[#EADFC6] p-7 h-full flex flex-col">
            <div className="flex items-start gap-3" data-testid="location-address-info">
              <span className="w-11 h-11 rounded-xl bg-[#EFE7D6] flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5 text-[#A6823B]" />
              </span>
              <div>
                <h4 className="font-display font-bold text-[#2A2521]">Adresă</h4>
                <p className="text-[#6B5C43] mt-1">{ADDRESS}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 mt-6" data-testid="location-hours-info">
              <span className="w-11 h-11 rounded-xl bg-[#EFE7D6] flex items-center justify-center shrink-0">
                <Clock className="w-5 h-5 text-[#A6823B]" />
              </span>
              <div>
                <h4 className="font-display font-bold text-[#2A2521]">Program</h4>
                <ul className="mt-1 space-y-1">
                  <li className="flex justify-between gap-6 text-sm text-[#6B5C43]"><span>Luni – Vineri</span><span className="font-medium text-[#2A2521]">08:00 – 20:00</span></li>
                  <li className="flex justify-between gap-6 text-sm text-[#6B5C43]"><span>Sâmbătă</span><span className="font-medium text-[#2A2521]">09:00 – 14:00</span></li>
                  <li className="flex justify-between gap-6 text-sm text-[#6B5C43]"><span>Duminică</span><span className="font-medium text-[#2A2521]">Închis</span></li>
                </ul>
              </div>
            </div>
            <div className="flex items-start gap-3 mt-6" data-testid="location-email-info">
              <span className="w-11 h-11 rounded-xl bg-[#EFE7D6] flex items-center justify-center shrink-0">
                <Mail className="w-5 h-5 text-[#A6823B]" />
              </span>
              <div>
                <h4 className="font-display font-bold text-[#2A2521]">Email</h4>
                <p className="text-[#6B5C43] mt-1">contact@mymedas.ro</p>
              </div>
            </div>
            <div className="mt-auto pt-7 flex flex-col sm:flex-row gap-3">
              <a
                href={PHONE_LINK}
                data-testid="location-phone-button"
                className="flex-1 inline-flex items-center justify-center gap-2 bg-[#A6823B] hover:bg-[#8A6B2E] text-white font-semibold px-5 py-3 rounded-full transition-colors"
              >
                <Phone className="w-4 h-4" /> {PHONE}
              </a>
              <a
                href={MAPS_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-directions-button"
                className="flex-1 inline-flex items-center justify-center gap-2 bg-white border border-[#EADFC6] hover:border-[#A6823B] text-[#2A2521] font-semibold px-5 py-3 rounded-full transition-colors"
              >
                <Navigation className="w-4 h-4" /> Direcții
              </a>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-3">
          <div className="rounded-2xl overflow-hidden border border-[#EADFC6] h-full min-h-[360px] shadow-lg shadow-[#2A2521]/5">
            <iframe
              title="Hartă MEDAS Stomatologie Timișoara"
              src="https://www.google.com/maps?q=Strada+Letea+25+Timisoara&output=embed"
              className="w-full h-full min-h-[360px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="location-map"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Location;
